if (window.innerWidth <= 768) {   
    const logoContainers = document.querySelectorAll('.logo_container');
    const updateHoverText = (target = null) => {
        document.querySelectorAll('.hover-text').forEach((hoverText) =>
            hoverText.classList.remove('text-hovered')
        );
        const activeContainer = target || document.querySelector('.logo_container.is-active');
        activeContainer?.querySelector('.hover-text')?.classList.add('text-hovered');      
    };
    logoContainers[0]?.querySelector('.hover-text')?.classList.add('text-hovered');
    logoContainers.forEach((ele) => {
        ele.addEventListener('click', () => updateHoverText(ele));
    });
    const observer = new MutationObserver(() => updateHoverText());
    logoContainers.forEach((container) => {
        observer.observe(container, { attributes: true, attributeFilter: ['class'] });
    });
}